import { render } from "./VendorsTable.vue?vue&type=template&id=72248cd8&scoped=true&lang=pug"
import script from "./VendorsTable.vue?vue&type=script&lang=ts"
export * from "./VendorsTable.vue?vue&type=script&lang=ts"

import "./VendorsTable.vue?vue&type=style&index=0&id=72248cd8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72248cd8"

export default script